/**页面导入，请勿手动修改本文件。本文件由build/gen.js自动生成*/
import Vue from 'vue'
/** 页面注册:S */
import charge_Detail from '@/pages/charge/Detail'
import charge_List from '@/pages/charge/List'
import charge_MobileCharge from '@/pages/charge/MobileCharge'
import homepage_Index from '@/pages/homepage/Index'
import orders_Cart from '@/pages/orders/Cart'
import orders_Charge from '@/pages/orders/Charge'
import orders_Detail from '@/pages/orders/Detail'
import orders_List from '@/pages/orders/List'
import orders_Logistics from '@/pages/orders/Logistics'
import orders_Wallet from '@/pages/orders/Wallet'
import orders_YixiaofuCharge from '@/pages/orders/YixiaofuCharge'
import payment_Payment from '@/pages/payment/Payment'
import payment_SelectAddress from '@/pages/payment/SelectAddress'
import products_Categorys from '@/pages/products/Categorys'
import products_Detail from '@/pages/products/Detail'
import products_List from '@/pages/products/List'
import public_NoAuth from '@/pages/public/NoAuth'
import public_PC from '@/pages/public/PC'
import public_Sorry from '@/pages/public/Sorry'
import setting_AddAddress from '@/pages/setting/AddAddress'
import setting_AddressList from '@/pages/setting/AddressList'
import setting_EditAddress from '@/pages/setting/EditAddress'
import setting_Index from '@/pages/setting/Index'
import setting_Phones from '@/pages/setting/Phones'
import superBusinessCard_ExchangeCard from '@/pages/superBusinessCard/ExchangeCard'
import superBusinessCard_ExchangeDetails from '@/pages/superBusinessCard/ExchangeDetails'
import superBusinessCard_MyCard from '@/pages/superBusinessCard/MyCard'
import superBusinessCard_UsageGuidelines from '@/pages/superBusinessCard/UsageGuidelines'
import wenhuajifen_Charge from '@/pages/wenhuajifen/Charge'
import wenhuajifen_Orders from '@/pages/wenhuajifen/Orders'

var router = [];

router.push({
    path: '/pages/charge/Detail',
    name: 'charge_Detail',
    component: charge_Detail
});

router.push({
    path: '/pages/charge/List',
    name: 'charge_List',
    component: charge_List
});

router.push({
    path: '/pages/charge/MobileCharge',
    name: 'charge_MobileCharge',
    component: charge_MobileCharge
});

router.push({
    path: '/pages/homepage/Index',
    name: 'homepage_Index',
    component: homepage_Index
});

router.push({
    path: '/pages/orders/Cart',
    name: 'orders_Cart',
    component: orders_Cart
});

router.push({
    path: '/pages/orders/Charge',
    name: 'orders_Charge',
    component: orders_Charge
});

router.push({
    path: '/pages/orders/Detail',
    name: 'orders_Detail',
    component: orders_Detail
});

router.push({
    path: '/pages/orders/List',
    name: 'orders_List',
    component: orders_List
});

router.push({
    path: '/pages/orders/Logistics',
    name: 'orders_Logistics',
    component: orders_Logistics
});

router.push({
    path: '/pages/orders/Wallet',
    name: 'orders_Wallet',
    component: orders_Wallet
});

router.push({
    path: '/pages/orders/YixiaofuCharge',
    name: 'orders_YixiaofuCharge',
    component: orders_YixiaofuCharge
});

router.push({
    path: '/pages/payment/Payment',
    name: 'payment_Payment',
    component: payment_Payment
});

router.push({
    path: '/pages/payment/SelectAddress',
    name: 'payment_SelectAddress',
    component: payment_SelectAddress
});

router.push({
    path: '/pages/products/Categorys',
    name: 'products_Categorys',
    component: products_Categorys
});

router.push({
    path: '/pages/products/Detail',
    name: 'products_Detail',
    component: products_Detail
});

router.push({
    path: '/pages/products/List',
    name: 'products_List',
    component: products_List
});

router.push({
    path: '/pages/public/NoAuth',
    name: 'public_NoAuth',
    component: public_NoAuth
});

router.push({
    path: '/pages/public/PC',
    name: 'public_PC',
    component: public_PC
});

router.push({
    path: '/pages/public/Sorry',
    name: 'public_Sorry',
    component: public_Sorry
});

router.push({
    path: '/pages/setting/AddAddress',
    name: 'setting_AddAddress',
    component: setting_AddAddress
});

router.push({
    path: '/pages/setting/AddressList',
    name: 'setting_AddressList',
    component: setting_AddressList
});

router.push({
    path: '/pages/setting/EditAddress',
    name: 'setting_EditAddress',
    component: setting_EditAddress
});

router.push({
    path: '/pages/setting/Index',
    name: 'setting_Index',
    component: setting_Index
});

router.push({
    path: '/pages/setting/Phones',
    name: 'setting_Phones',
    component: setting_Phones
});

router.push({
    path: '/pages/superBusinessCard/ExchangeCard',
    name: 'superBusinessCard_ExchangeCard',
    component: superBusinessCard_ExchangeCard
});

router.push({
    path: '/pages/superBusinessCard/ExchangeDetails',
    name: 'superBusinessCard_ExchangeDetails',
    component: superBusinessCard_ExchangeDetails
});

router.push({
    path: '/pages/superBusinessCard/MyCard',
    name: 'superBusinessCard_MyCard',
    component: superBusinessCard_MyCard
});

router.push({
    path: '/pages/superBusinessCard/UsageGuidelines',
    name: 'superBusinessCard_UsageGuidelines',
    component: superBusinessCard_UsageGuidelines
});

router.push({
    path: '/pages/wenhuajifen/Charge',
    name: 'wenhuajifen_Charge',
    component: wenhuajifen_Charge
});

router.push({
    path: '/pages/wenhuajifen/Orders',
    name: 'wenhuajifen_Orders',
    component: wenhuajifen_Orders
});

/** 页面注册:E */
export default router


// WEBPACK FOOTER //
// ./src/router/Pages.js